import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MinusIcon, PlusIcon, Trash2Icon } from "lucide-react";
import { useCart, type CartItem } from "../contexts/CartContext";
import { formatPrice, shopifyImg } from "../utils/format";
import { ease } from "../utils/styles";
interface CartLineProps {
  item: CartItem;
  compact?: boolean;
}
export function CartLine({
  item,
  compact = false
}: CartLineProps) {
  const {
    updateQty,
    remove,
    close
  } = useCart();
  const href = `/product/${item.product.id}`;
  return <motion.li layout initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    x: 24
  }} transition={{
    duration: 0.22,
    ease
  }} className={`flex gap-4 ${compact ? "py-3" : "py-4"}`} data-id="element-56" data-mp="7zpewt7q25r7">
      <Link to={href} onClick={close} className="shrink-0" data-id="element-57" data-mp="2oqpibj6y6k2w">
        <img src={shopifyImg(item.product.image, compact ? 240 : 400)} alt={item.product.imageAlt} className={`rounded-2xl bg-sand object-cover ${compact ? "h-24 w-20" : "h-32 w-28"}`} data-id="element-58" data-mp="2oo34j1tgr8c8" />
      </Link>
      <div className="flex min-w-0 flex-1 flex-col py-1" data-id="element-59" data-mp="3lzloigf4qr9v">
        <div className="flex justify-between gap-3" data-id="element-60" data-mp="3qz81qpuyk7io">
          <div className="min-w-0" data-id="element-61" data-mp="3d10bt1wca6h0">
            <Link to={href} onClick={close} className={`block truncate font-medium text-ink ${compact ? "text-[15px]" : "text-lg"}`} data-id="element-62" data-mp="3czyo9xy4zrie">
              {item.product.name}
            </Link>
            <p className="truncate text-sm text-muted" data-id="element-63" data-mp="33aozaqylaoyi">
              {[item.color, item.note && `“${item.note}”`].filter(Boolean).join(" · ") || item.product.type}
            </p>
          </div>
          <p className="shrink-0 text-[15px] text-ink" data-id="element-64" data-mp="2ub1vxzmav92t">{formatPrice(item.product.price * item.qty)}</p>
        </div>
        <div className="mt-auto flex items-center justify-between pt-2" data-id="element-65" data-mp="2ycndvzdoydjv">
          <div className="flex h-9 items-center rounded-full bg-sand" data-id="element-66" data-mp="2kbjepqxry1eg">
            <button type="button" onClick={() => updateQty(item.key, item.qty - 1)} className="flex h-9 w-9 items-center justify-center rounded-full" aria-label={`Minder ${item.product.name}`} data-id="element-67" data-mp="2pb60wpvkyrze">
              <MinusIcon className="h-3.5 w-3.5" data-id="element-68" data-mp="uws8l7gtg319" />
            </button>
            <span className="w-5 text-center text-sm tabular-nums" data-id="element-69" data-mp="q2nv05d1owr7">{item.qty}</span>
            <button type="button" onClick={() => updateQty(item.key, item.qty + 1)} className="flex h-9 w-9 items-center justify-center rounded-full" aria-label={`Meer ${item.product.name}`} data-id="element-70" data-mp="m3f6bewv3p2i">
              <PlusIcon className="h-3.5 w-3.5" data-id="element-71" data-mp="1dsrxuaiessh5" />
            </button>
          </div>
          <button type="button" onClick={() => remove(item.key)} className="flex h-9 w-9 items-center justify-center rounded-full text-muted transition-colors duration-150 hover:bg-sand hover:text-ink" aria-label={`${item.product.name} verwijderen`} data-id="element-72" data-mp="19ryelufww1ul">
            <Trash2Icon className="h-4 w-4" data-id="element-73" data-mp="zw4r5g0nmny1" />
          </button>
        </div>
      </div>
    </motion.li>;
}